import { ChangeEvent } from 'react';
import { Box } from '@nimbus-ds/components';
import { AddressInfoSection } from './AddressInfoSection';
import { ContactInfoSection } from './ContactInfoSection';
import { PersonalInfoSection } from './PersonalInfoSection';
import { useGetCountriesList, useGetProvincesList } from '../../../../hooks';
import { RegistrationFormValues, RegistrationFormErrors } from '../../types';

interface RegistrationInfoProps {
  values: RegistrationFormValues;
  errors: Partial<RegistrationFormErrors>;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeSelect: (e: ChangeEvent<HTMLSelectElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  isInitialDataLoading: boolean;
}

export function RegistrationInfo({
  values,
  errors,
  handleChange,
  handleChangeSelect,
  handleBlur,
  isInitialDataLoading,
}: Readonly<RegistrationInfoProps>) {
  const countries = useGetCountriesList();
  const { provinces, isLoading: isLoadingProvinces } = useGetProvincesList(
    values.country,
  );

  const isCountriesLoading = isInitialDataLoading || countries.length === 0;

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <PersonalInfoSection
        firstName={values.firstName}
        lastName={values.lastName}
        ownerEmail={values.ownerEmail}
        errors={{
          firstName: errors.firstName,
          lastName: errors.lastName,
          ownerEmail: errors.ownerEmail,
        }}
        handleChange={handleChange}
        handleBlur={handleBlur}
        isLoading={isInitialDataLoading}
      />

      <ContactInfoSection
        country={values.country}
        phone={values.phone}
        countries={countries}
        errors={{
          country: errors.country,
          phone: errors.phone,
        }}
        handleChange={handleChange}
        handleChangeSelect={handleChangeSelect}
        handleBlur={handleBlur}
        isCountriesLoading={isCountriesLoading}
      />

      <AddressInfoSection
        zipCode={values.zipCode}
        address={values.address}
        state={values.state}
        city={values.city}
        country={values.country}
        provinces={provinces}
        errors={{
          zipCode: errors.zipCode,
          address: errors.address,
          state: errors.state,
          city: errors.city,
        }}
        handleChange={handleChange}
        handleChangeSelect={handleChangeSelect}
        handleBlur={handleBlur}
        isLoadingProvinces={isLoadingProvinces}
      />
    </Box>
  );
}
